import React, { FC } from 'react';
import { Attachment } from '../../../../../../interfaces/Attachment';
import AttachmentLink from './AttachmentLink';
import { StyledList } from './Attachments.styles';

export interface AttachmentsProps {
  attachments: Attachment[];
}
const Attachments: FC<AttachmentsProps> = ({ attachments }) => {
  if (!attachments || attachments.length === 0) {
    return null;
  }
  return (
    <StyledList data-testid="attachments">
      {attachments?.map((attachment) => (<AttachmentLink key={attachment.id} attachment={attachment} />))}
    </StyledList>
  );
};

export default (Attachments);
